import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './pages/Login';
import ProjectDetails from "./pages/checkList/ProjectDetails";
import Dashboard from './pages/dashboard/Dashboard';
import LandingPage from './pages/LandingPage'
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "font-awesome/css/font-awesome.min.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const queryClient = new QueryClient();
function App() {
  useEffect(() => {
    const onStorageChange = (event) => {
      if (event.key === "logoutEvent") {
        localStorage.removeItem("authToken");
        localStorage.removeItem("userRole");
        localStorage.removeItem("User");

          window.location.href = "/";
      }
    };

    window.addEventListener("storage", onStorageChange);

    // Cleanup listener when App unmounts
    return () => window.removeEventListener("storage", onStorageChange);
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
       {/* ✅ Global Toast Container */}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
      />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/project-details" element={<ProjectDetails />} />
         <Route
            path="/project-details/:hotelId"
            element={<ProjectDetails />}
          />
            {/* <Route path="/project-details/:hotelId?" element={<ProjectDetails />} /> */}
        <Route path="/landingPage" element={<LandingPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
    </Router>
    </QueryClientProvider>
    
  );
}


export default App;
